module.exports = __webpack_public_path__ + "img/ThomasJochimski_140x140_rund.a2341834.jpg";